export const PANDA_COLORS = {
  lightBlack: '#393955',
  black: '#333333',
  blueLight: '#6585F5',
  blue: '#3F66F3',
  blueDark: '#2346C4',
  blueHover: '#EBEFFD',
  grayBorder: '#EBEAE9',
  grayFadedBorder: '#B0B0BB',
  grayText: '#616177',
  grayTextDisabled: '#B0B0BB',
  grayDisabled: '#D8D6D4',
  grayBackground: '#F6F4F1',
  grayLightDisabled: '#E9E3DB',
  grayHover: '#BFBFBF',
  purple: '#393955',
  white: '#FFFFFF',
  red: '#F6564D',
};

export const PANDA_FULL_COLORS = {
  blue: '#3F66F3',
  black: '#393955',
  magenta: '#F33F71',
  cyan: '#393955',
  teal: '#F33F71',
  green: '#25993D',
  yellow: '#E9A400',
  orange: '#FF6E2A',
  red: '#F6564D',
  pink: '#F355A8',
  purple: '#774DF6',
  gray: '#7F7972',
  white: '#FFFFFF',
};

export const PANDA_THEME_COLORS = {
  black: '#333333',
  gray: '#616177',
  white: '#FFFFFF',
  red: '#F6564D',
  blue: '#3F66F3',
};
